'use strict';
import classNames from 'classnames';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import React from 'react';
import {I18nMessage} from '../../../../../components/I18nMessage';
import {responseFieldViewpropTypes} from '../utils';


export function ListFieldViewView(props) {
  return (
    <p className={classNames("ListFieldView", props.className)}>
      {renderResult(props)}
    </p>
  );
}

ListFieldViewView.propTypes = responseFieldViewpropTypes;

function renderResult(props) {
  const result = props.value;
  const {options} = props.field;

  if (options.selectMany) {
    if (isArray(result) && result.length > 0) {
      return result
        .map(item => item.label)
        .join(', ');
    } else {
      return (
        <i>
          <I18nMessage message="forms.response.default.placeholder" />
        </i>
      );
    }

  } else {
    return get(result, 'label', null) ? (
      result.label
    ) : (
      <i>
        <I18nMessage message="forms.response.default.placeholder" />
      </i>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/form-builder/components/response/fields/ListFieldView/ListFieldViewView.js